import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../../../../core/components/modals/base-modal/base-modal.component";
import {
  DelayedFileUploadCardComponent
} from "../../../../../shared/components/ui/delayed-file-upload-card/delayed-file-upload-card.component";
import {MatButton} from "@angular/material/button";
import {FilesService} from "../../../../../core/services/files.service";
import {uploadProductPackagesModalName} from "./configs/upload-packages-excel-moda-config";
import {
  EXCEL_EXTENSIONS
} from "../../../../../core/components/modals/upload-excel-modal/configs/upload-excel-modal-config";
import {UploadProductPackagesExcelParams} from "./types/upload-packages-excel.types";
import {UploadPackagesExcelService} from "./services/upload-packages-excel.service";

@Component({
  selector: 'app-upload-packages-excel-modal',
  imports: [
    BaseModalComponent,
    DelayedFileUploadCardComponent,
    MatButton
  ],
  templateUrl: './upload-packages-excel-modal.component.html',
  styleUrl: './upload-packages-excel-modal.component.scss'
})
export class UploadPackagesExcelModalComponent extends BaseModalComponent {
  private filesService: FilesService = inject(FilesService);
  private uploadPackagesExcelService: UploadPackagesExcelService = inject(UploadPackagesExcelService);

  public readonly excelExtensions = EXCEL_EXTENSIONS;
  public selectedFile: File | null = null;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(uploadProductPackagesModalName);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(uploadProductPackagesModalName);
  }

  public filesSelectedForUpload(files: Array<File>): void {
    this.selectedFile = files[0];
  }

  public async handleUploadExcel(): Promise<void> {
    if (!this.selectedFile) {
      this.errorService.showErrorMessage('Загрузите файл!')
      return;
    }

    const formData = this.filesService.createFormData({
      file: this.selectedFile,
      fileType: 'file'
    });

    const uploadProductPackagesExcelParams: UploadProductPackagesExcelParams = {
      file: formData,
      path: 'product-packages/import-bulk',
      fileName: this.selectedFile?.name
    };

    this.loadingService.setIsLoadingState(true);
    await this.uploadPackagesExcelService.importProductPackagesExcel(uploadProductPackagesExcelParams)
      .then(() => this.successImport())
      .catch(() => this.closeDialog('cancel'))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }

  private successImport(): void {
    this.snackbarService.successShowMessage('Файл успешно загружен!');
    this.closeDialog('success');
  }
}
